import { t } from 'i18next'
import { z } from 'zod'

import { ClienteRegimeCasamentoEnum, tipoAssinaturaEnum } from '@/features/proposta/interfaces/proposta.enums'
import { EstadoCivilEnum } from '@/shared/interfaces/cliente.enums'
import { telefoneSchema } from '@/shared/schemas/telefone.schema'

export const contatoSchema = z
  .object({
    telefone: telefoneSchema,
    email: z
      .string()
      .email(t('proposta:cadastro_compradores.steps.contatos.erro.email_invalido'))
      .nullish()
      .refine((email) => !!email?.length, {
        message: t('proposta:cadastro_compradores.steps.contatos.erro.email_obrigatorio'),
      }),
  })
  .transform(({ telefone, ...rest }) => ({
    telefone: {
      ...telefone,
      origem: telefone!.origem,
      numero: telefone!.numero.replaceAll(/\D/g, ''),
    },
    email: rest.email!,
  }))
export type CompradorContatoSchemaOutput = z.output<typeof contatoSchema>

export const estadoCivilSchema = z.object({
  status: z
    .nativeEnum(EstadoCivilEnum, { errorMap: () => ({ message: 'Informe o estado civil do comprador' }) })
    .nullish(),
  uniaoEstavel: z.enum(['sim', 'nao', '']).nullish(),
  regimeCasamento: z.nativeEnum(ClienteRegimeCasamentoEnum).nullish(),
  tipoAssinatura: z.nativeEnum(tipoAssinaturaEnum).nullish(),
})

export type EstadoCivilSchemaInput = z.input<typeof estadoCivilSchema>

export const transformEstadoCivil = (data: z.infer<typeof estadoCivilSchema>) => {
  if (!data) return data
  return {
    ...data,
    possuiUniaoEstavel: data.uniaoEstavel ? data.uniaoEstavel === 'sim' : null,
    regimeCasamento: data.regimeCasamento ?? null,
  }
}
